import { Color, RGBColor } from "../defines/colors"
import { Symbol } from "../defines/symbols"
import { TapestryTile, Tile } from "../defines/types"

function isBlockingTile(tile: Tile): boolean {
  return tile.light.symbol == Symbol.DEVOURER || tile == WALL_TILE
}

const FLOOR_TILE: Tile = {
  walkable: true,
  dark: {
    symbol: "",
    fg: Color.FLOOR_TILE_DARK_FG,
    bg: Color.FLOOR_TILE_DARK_BG,
  },
  light: { symbol: "", fg: Color.FLOOR_TILE_FG, bg: Color.FLOOR_TILE_BG },
  transparent: true,
  visible: false,
  seen: false,
}

const WALL_TILE: Tile = {
  walkable: false,
  dark: {
    symbol: "",
    fg: Color.WALL_TILE_DARK_FG,
    bg: Color.WALL_TILE_DARK_BG,
  },
  light: { symbol: "", fg: Color.WALL_TILE_FG, bg: Color.WALL_TILE_BG },
  transparent: false,
  visible: false,
  seen: false,
}

const DANGER_TILE: Tile = {
  walkable: true,
  dark: {
    symbol: "",
    fg: Color.DANGER_TILE_DARK,
    bg: Color.DANGER_TILE_DARK,
  },
  light: { symbol: "", fg: Color.DANGER_TILE, bg: Color.DANGER_TILE },
  transparent: true,
  visible: false,
  seen: false,
}

const HILITE_TILE: Tile = {
  walkable: true,
  dark: {
    symbol: " ",
    fg: Color.HILITE_TILE_DARK_FG,
    bg: Color.HILITE_TILE_DARK_BG,
  },
  light: { symbol: " ", fg: Color.HILITE_TILE_FG, bg: Color.HILITE_TILE_BG },
  transparent: true,
  visible: false,
  seen: false,
}

const BACKGROUND_TILE: TapestryTile = {
  symbol: " ",
  fg: RGBColor.TAPESTRY_NOTHING,
  bg: RGBColor.TAPESTRY_BACKGROUND,
}

const BLACK_TILE: TapestryTile = {
  symbol: " ",
  fg: RGBColor.TAPESTRY_NOTHING,
  bg: RGBColor.TAPESTRY_NOTHING,
}

const GRAY_TILE: TapestryTile = {
  symbol: " ",
  fg: RGBColor.GRAY,
  bg: RGBColor.GRAY,
}

const BORDER_TILE: TapestryTile = {
  symbol: " ",
  fg: RGBColor.TAPESTRY_NOTHING,
  bg: RGBColor.TAPESTRY_BORDER,
}

export {
  BACKGROUND_TILE,
  BLACK_TILE,
  BORDER_TILE,
  DANGER_TILE,
  FLOOR_TILE,
  GRAY_TILE,
  HILITE_TILE,
  isBlockingTile,
  TapestryTile,
  Tile,
  WALL_TILE,
}
